import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface AuthRouteProps {
  element: React.ReactNode;
}

export function AuthRoute({ element }: AuthRouteProps) {
  const { currentUser } = useAuth();
  const location = useLocation();

  // Allow authenticated users to access the payment page
  if (currentUser && location.pathname !== "/register/payment") {
    return <Navigate to="/" />;
  }

  return <>{element}</>;
}
